import confinamento from './confinamento'
import pasto from './pasto'

export default {
    confinamento,
    pasto
}


// WEBPACK FOOTER //
// ./src/services/relatorio/comparativo/index.js